import { access_check_lists_form, access_dashboard } from "../../helpers/rights/rights";
import { useHasPermission } from "../../modules/permission/hooks/useHasPermission";
import CheckList from "../checkLists/checkList";
import Dashboard from "../dashboard/dashboard";

const Home = () => {
	const accessDashboard = useHasPermission([access_dashboard], { shouldView: true })
	const accessCheckListsForm = useHasPermission([access_check_lists_form], { shouldView: true })
	return (
		<>
			{accessDashboard && (<Dashboard/>)}
			{accessCheckListsForm && (<CheckList/>)}
		</>
	);
};

export default Home